import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2ReviewStatus } from '@/api/model/interfaces';

export default class PackageKS2ReviewStatusOdata extends OdataManager<PackageKS2ReviewStatus> {}
